import { render, staticRenderFns } from "./EmployeeHierarchyPage.vue?vue&type=template&id=67864b33&scoped=true&lang=pug&"
import script from "./EmployeeHierarchyPage.vue?vue&type=script&lang=ts&"
export * from "./EmployeeHierarchyPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67864b33",
  null
  
)

export default component.exports